module.exports = __webpack_public_path__ + "static/media/slidee-1.f6976d7e.jpg";